import React, { Component } from "react";
import { Tabs, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import HouseDetailPageInfo from "../../data/HouseDetailPageInfo";
import LandDetailPageInfo from "../../data/LandDetailPageInfo"; // 👈 yeni import

class TabStyleThree extends Component {
  findImage = (src) => {
    if (!src) return "/images/default-house.jpg";
    const normalized = src.replace(/\.jpeg$/i, ".jpg");
    return normalized;
  };

  render() {
    const { column, dataType = "house" } = this.props;

    // 👇 veri kaynağını seçiyoruz
    const data = dataType === "land" ? LandDetailPageInfo : HouseDetailPageInfo;

    return (
      <div>
        <Tabs>
          <TabPanel className="row row--35">
            {data.map((item, index) => {
              const firstImage =
                item.content.find((c) => c.type === "image")?.src ||
                item.PortfolioList2?.[0]?.image ||
                `/images/${dataType}/${item.slug}/1.jpg`;

              const safeImage = this.findImage(firstImage);

              return (
                <div className={`${column}`} key={index}>
                  <div className="item-portfolio-static">
                    <div className="portfolio-static">
                      <div className="thumbnail-inner">
                        <div className="thumbnail">
                          <Link
                            to={{
                              pathname: `/${item.slug}`,
                              state: { blog: item },
                            }}
                          >
                            <img
                              src={safeImage}
                              alt={item.title}
                              onError={(e) =>
                                (e.currentTarget.src =
                                  "/images/default-house.jpg")
                              }
                              className="house-thumb"
                            />
                          </Link>
                        </div>
                      </div>

                      <div className="content">
                        <div className="inner">
                          <h4>
                            <Link
                              to={{
                                pathname: `/${item.slug}`,
                                state: { blog: item },
                              }}
                            >
                              {item.title}
                            </Link>
                          </h4>
                          <p>{item.secondTitle}</p>
                          <p>{item.description}</p>
                          <div className="property-info">
                            {item.beds && (
                              <span className="info-item">
                                <i className="fa-solid fa-bed"></i> {item.beds}
                              </span>
                            )}

                            {item.baths && (
                              <span className="info-item">
                                <i className="fa-solid fa-shower"></i>
                                {item.baths}
                              </span>
                            )}

                            {item.area && (
                              <span className="info-item">
                                <i className="fa fa-expand"></i>
                                {item.area}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

export default TabStyleThree;
